import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { DragAndDropBoxContainerStyled as Container, DragAndDropBoxHiddenInputStyled as HiddenInput, DragAndDropBoxCaptionContainerStyled as CaptionContainer, SSITextH2Styled as Caption, DragAndDropBoxDescriptionStyled as Description, } from '../../../styles';
const DragAndDropBox = (props) => {
    const { caption, description, onChangeFile } = props;
    const inputFile = useRef(null);
    const onSelect = async () => {
        inputFile.current?.click();
    };
    const onChange = async (event) => {
        const file = event.target.files?.[0];
        if (file) {
            await onChangeFile(file);
        }
    };
    const onDrop = async (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        const reader = new FileReader();
        reader.onload = async () => {
            await onChangeFile(file);
        };
        reader.readAsText(file);
    };
    const onDragOver = async (event) => {
        event.preventDefault();
    };
    return (_jsxs(Container, { onClick: onSelect, onDrop: onDrop, onDragOver: onDragOver, children: [_jsx(HiddenInput, { ref: inputFile, type: "file", onChange: onChange }), _jsxs(CaptionContainer, { children: [_jsx(Caption, { children: caption }), _jsx(Description, { children: description })] })] }));
};
export default DragAndDropBox;
